export default class Dataquotation {
  constructor(bRoot) {
    this.bRoot = bRoot;
    this.app = "/data/";
    this.initialize = this.initialize.bind(this);
  }

  async search(campaign_id, person_id, state_id, crop_id, order_by, page) {
    let endpoint =
      this.app +
      "quotations_hierarchy_list/" +
      campaign_id.toString() +
      "/" +
      person_id.toString() +
      "/" +
      state_id.toString() +
      "/" +
      crop_id.toString() +
      "/" +
      (order_by ? order_by : "");

    return await this.bRoot.search(endpoint, null, null, null, page);
  }

  async get(campaign_id, quotation_id) {
    let endpoint =
      this.app +
      "quotations_hierarchy/" +
      campaign_id.toString() +
      "/0/0/0/" +
      quotation_id.toString() +
      "/-id";

    let quotation = await this.bRoot.search(endpoint, null, null, null, 1);
    return quotation.data.results[0];
  }
  /* eslint-disable */
  async duplicate(quotation) {
    let new_quotation = { ...quotation };
    new_quotation.url = null;
    new_quotation.id = null;
    new_quotation.code = null;
    new_quotation.commercial_person = this.bRoot.appInfo.commercial_person.url,
    new_quotation.commercial_person_name = this.bRoot.appInfo.commercial_person.person.name,
    new_quotation.date = this.bRoot.moment().format("YYYY-MM-DD"),
    new_quotation.date_formatted = this.bRoot.moment().format("DD/MM/YYYY"),
    new_quotation.quotation_items.forEach(item => {
      item.id = null;
      delete item.quotation;
    });
    new_quotation = await this.setSaleConditionAllItems(new_quotation);
    return new_quotation;
  }
  /* eslint-enable */

  async getCampaigns() {
    // eslint-disable-next-line
    let campaigns = await this.bRoot.search(this.app + "campaigns", null, "code", "orders_enabled__in=S,D");
    for (let camp in campaigns.data.results) {
      if (
        this.bRoot.auth.current_level != 0 &&
        campaigns.data.results[camp].quotations_enabled == "D"
      ) {
        campaigns.data.results.splice(camp, 1);
      }
    }
    return campaigns;
  }

  async getDocument() {
    // eslint-disable-next-line
    let response = await this.bRoot.search(this.app + "order_documents", null, "id", "code=NV");
    return response.data ? response.data.results[0] : null;
  }

  async getCrops() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "crops", null, "code", null);
  }

  async getStates() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "quotation_states", null, "code", null);
  }

  async getSalesMethods() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "sale_methods", null, "code", null);
  }

  async getPaymentConditions() {
    let paymentConditions = await this.bRoot.search(
      this.app + "payment_conditions",
      null,
      "code",
      null
    );
    return paymentConditions.data.results.map(object => {
      object.display_description = object.code + " - " + object.description;
      return object;
    });
  }

  async getDiscountCode(code) {
    let DiscountCode = await this.bRoot.search(
      this.app + "discount_codes",
      null,
      "code",
      "code=" + code.toString()
    );
    if (DiscountCode.data) {
      return DiscountCode.data.results[0];
    }
  }

  async getDiscountScales(quotation) {
    let filterString = "discount_code=2";
    if (!quotation.person) {
      return null;
    } else {
      filterString =
        filterString +
        "&category__id=" +
        quotation.person_category_id.toString();
    }
    if (!quotation.crop_object) {
      return null;
    } else {
      filterString =
        filterString + "&crop__id=" + quotation.crop_object.id.toString();
    }
    filterString =
      filterString +
      "&from_date__lte=" +
      this.bRoot.moment(quotation.date).format("YYYY-MM-DD") +
      " 00:00:00" +
      "&to_date__gte=" +
      this.bRoot.moment(quotation.date).format("YYYY-MM-DD") +
      " 00:00:00";

    let discountScales = await this.bRoot.searchAll(
      "data/discounts",
      null,
      "to_quantity",
      filterString
    );
    return discountScales;
  }

  async initialize(quotable_person, campaign, crop) {
    let object = {
      url: null,
      id: null,
      code: null,
      commercial_person: this.bRoot.appInfo.commercial_person.url,
      commercial_person_name: this.bRoot.appInfo.commercial_person.person.name,
      date: this.bRoot.moment().format("YYYY-MM-DD"),
      date_formatted: this.bRoot.moment().format("DD/MM/YYYY"),
      sale_method: null,
      total_quantity: 0,
      advance_dispatch: false,
      comments: null,
      internal_comments: null,
      backend_code: null,
      can_edit: true,
      can_print: false,
      has_company_discount: false,
      errors: null,
      quotation_items: []
    };
    object.state = null;
    object = await this.setPerson(object, quotable_person);
    object = await this.setPaymentCondition(object, null, null);
    /* setCampaing limpia ítems preexistentes y agrega uno nuevo*/
    object = await this.setCampaign(object, campaign);
    object = await this.setCrop(object, crop);
    return object;
  }

  async setPerson(quotation, qp) {
    quotation.person = qp ? qp.person : null;
    quotation.client = qp ? qp.client : null;
    quotation.producer = qp ? qp.producer : null;
    quotation.person_id = qp ? qp.id : 0;
    quotation.person_name = qp ? qp.name : null;
    quotation.person_category_id = qp ? qp.person_category_id : 0;
    quotation.person_category_description = qp
      ? qp.person_category_description
      : null;
    quotation.person_category_code = qp ? qp.person_category_code : null;
    // eslint-disable-next-line
    quotation.person_identification_type_code = qp ? qp.person_identification_type_code : null;
    quotation.person_identification = qp ? qp.person_identification : null;
    quotation = await this.setPaymentCondition(quotation, null, null);
    quotation.client_code = qp ? qp.client_code : null;
    quotation = await this.setSaleConditionAllItems(quotation); // eslint-disable-line
    return quotation;
  }

  async setCampaign(quotation, campaign, campaignUrl) {
    if (!campaign && campaignUrl) {
      try {
        this.bRoot.disableAlerts = true;
        campaign = await this.bRoot.getObjectByURL(campaignUrl);
      } catch {
        campaign = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    quotation.campaign_object = campaign;
    quotation.campaign = campaign ? campaign.url : null;
    quotation.campaign_id = campaign ? campaign.id : 0;
    quotation.campaign_code = campaign ? campaign.code : null;
    quotation = await this.setCropCampaignParameters(quotation);
    quotation = await this.clearItems(quotation);
    return quotation;
  }

  async setCrop(quotation, crop, cropUrl) {
    if (!crop && cropUrl) {
      try {
        this.bRoot.disableAlerts = true;
        crop = await this.bRoot.getObjectByURL(cropUrl);
      } catch {
        crop = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    quotation.crop_object = crop;
    quotation.crop = crop ? crop.url : null;
    quotation.crop_id = crop ? crop.id : 0;
    quotation.crop_code = crop ? crop.code : null;
    quotation.crop_description = crop ? crop.description : null;
    quotation = await this.setCropCampaignParameters(quotation);
    quotation = await this.clearItems(quotation);
    return quotation;
  }

  async setPaymentCondition(quotation, paymentCondition, paymentConditionUrl) {
    if (!paymentCondition && paymentConditionUrl) {
      try {
        this.bRoot.disableAlerts = true;
        paymentCondition = await this.bRoot.getObjectByURL(paymentConditionUrl);
      } catch {
        paymentCondition = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    quotation.payment_condition_object = paymentCondition;
    quotation.payment_condition = paymentCondition ? paymentCondition.url : null; // eslint-disable-line
    quotation.payment_condition_id = paymentCondition ? paymentCondition.id : 0;
    quotation.requires_broker = false;
    if (paymentCondition) {
      if (paymentCondition.payment_form_object) {
        if (paymentCondition.payment_form_object.requires_broker) {
          quotation.requires_broker =
            paymentCondition.payment_form_object.requires_broker;
        }
      }
    }
    if (quotation.requires_broker === false) {
      quotation = await this.setBroker(quotation);
    }
    quotation.interest = paymentCondition ? paymentCondition.interest : 0;
    quotation.payment_condition_description =  (paymentCondition ? paymentCondition.description : null); //eslint-disable-line
    quotation.payment_condition_term = paymentCondition ? paymentCondition.term : 0; // eslint-disable-line
    quotation = await this.setSaleConditionAllItems(quotation);
    return quotation;
  }

  async setBroker(quotation, broker, brokerUrl) {
    if (!broker && brokerUrl) {
      try {
        this.bRoot.disableAlerts = true;
        broker = await this.bRoot.getObjectByURL(brokerUrl);
      } catch {
        broker = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    quotation.broker = broker ? broker.url : null;
    quotation.broker_id = broker ? broker.id : 0;
    quotation.broker_code = broker ? broker.code : null;
    quotation.broker_name = broker ? broker.name : null;
    return quotation;
  }

  async setCropCampaignParameters(quotation) {
    let defData = {
      max_discount: 0,
      delivery_period_size: 0,
      delivery_start_date: quotation.date,
      delivery_end_date: quotation.date
    };
    if (!quotation.campaign_object || !quotation.crop_object) {
      quotation.crop_campaign_parameters_object = defData;
    } else {
      let endpoint = "/data/crop_campaign_parameters";
      let filterString =
        "crop__id=" +
        quotation.crop_object.id.toString() +
        "&&campaign__id=" +
        quotation.campaign_object.id.toString();
      let response = await this.bRoot.search(
        endpoint,
        null,
        null,
        filterString
      );
      quotation.crop_campaign_parameters_object =
        response.data.length === 1 ? response.data[0] : defData;
    }
    return quotation;
  }

  async advanceDispatchChange(quotation) {
    quotation = await this.setSaleConditionAllItems(quotation);
    return quotation;
  }

  async totalQuantityChange(quotation) {
    quotation = await this.setSaleConditionAllItems(quotation);
    return quotation;
  }

  async clearItems(quotation) {
    quotation.quotation_items = [];
    quotation = await this.addNewItem(quotation);
    return quotation;
  }

  async addNewItem(quotation) {
    let maxId = 0;
    if (quotation.quotation_items.length > 0) {
      // eslint-disable-next-line
      maxId  = quotation.quotation_items.reduce((acc, cur ) => Math.max(acc, cur.item_number), quotation.quotation_items[0].item_number);
    }
    let newItem = this.getNewItem();
    newItem.item_number = ++maxId;
    quotation.quotation_items.push(newItem);
    return quotation;
  }

  async deleteItem(quotation, item) {
    let index = quotation.quotation_items.findIndex(
      i => i.item_number === item.item_number
    );
    if (index != -1) {
      quotation.quotation_items.splice(index, 1);
      /* renum items */
      let item_number = 1;
      let new_items = quotation.quotation_items.map(new_item => {
        new_item.item_number = item_number;
        item_number += 1;
        return new_item;
      });
      quotation.quotation_items = new_items;
    }
    return quotation;
  }

  async itemChange(quotation, item_index, fieldName, object) {
    let new_item = null;
    let validation_error = null;

    switch (fieldName) {
      case "inventory":
        new_item = await this.setItemProductFromInventory(
          quotation,
          quotation.quotation_items[item_index],
          object
        );
        new_item = await this.setSaleCondition(new_item, quotation);
        break;
      // eslint-disable-next-line
      case "unit_price_usd": case "leader_discount": case "company_discount":
        new_item = await this.itemRecalc(
          quotation.quotation_items[item_index],
          quotation
        );
        break;
      case "quantity":
        new_item = await this.itemQuantityChange(
          quotation.quotation_items[item_index],
          quotation
        );
        break;
      case "company_discount_motive":
        new_item = await this.setItemCompanyDiscountMotive(
          quotation.quotation_items[item_index],
          quotation,
          object
        );
        break;
      default:
        new_item = quotation.quotation_items[item_index];
        break;
    }
    quotation.quotation_items.splice(item_index, 1, new_item);
    try {
      await this.validateQuotationItemsMultiCrop(quotation);
    } catch (error) {
      validation_error = error;
    }
    return { quotation: quotation, error: validation_error };
  }

  async setItemProductFromInventory(quotation, item, inventory) {
    let newItem = this.getNewItem();
    if (quotation.url) {
      newItem.quotation = quotation.url;
    }
    newItem.item_number = item.item_number;
    newItem.id = item.id;
    newItem.product = inventory.product;
    newItem.product_id = inventory.product_id;
    newItem.product_code = inventory.product_code;
    newItem.product_description = inventory.product_description;
    newItem.gauge = inventory.gauge;
    newItem.gauge_id = inventory.gauge_id;
    newItem.gauge_code = inventory.gauge_code;
    newItem.gauge_description = inventory.gauge_description;
    newItem.curing = inventory.curing;
    newItem.curing_id = inventory.curing_id;
    newItem.curing_code = inventory.curing_code;
    newItem.curing_description = inventory.curing_description;
    newItem.serial_number = inventory.serial_number;
    newItem.available_amount = inventory.available_amount;
    newItem.crop_id = inventory.crop_id;
    newItem.crop_description = inventory.crop_description;
    newItem.band = inventory.band;
    newItem.campaign = inventory.campaign;
    newItem.band_data.band_id = inventory.band_id;
    newItem.band_data.band_description = inventory.band_description;
    return newItem;
  }

  async setSaleCondition(item, quotation) {
    let dat = null;
    if (
      quotation.campaign_id &&
      quotation.person_category_id &&
      quotation.payment_condition_id &&
      item.product_id
    ) {
      let endpoint =
        "/data/sales_condition/" +
        quotation.campaign_id.toString() +
        "/" +
        quotation.date +
        "/" +
        quotation.person_category_id.toString() +
        "/" +
        (quotation.person_category_code == "5" ? "0" : "1") + // force max_leader_discount
        "/" +
        quotation.payment_condition_id.toString() +
        "/" +
        (quotation.total_quantity ? quotation.total_quantity.toString() : "0") +
        "/" +
        (quotation.advance_dispatch ? "1" : "0") +
        "/" +
        item.product_id.toString() +
        "/" +
        item.gauge_id.toString() +
        "/" +
        item.curing_id.toString();

      let response = await this.bRoot.search(endpoint);
      dat = Array.isArray(response.data) ? response.data[0] : response.data;
    }
    item.list_unit_price_usd = dat ? dat.list_unit_price_usd : 0;
    item.interest = dat ? dat.interest : 0;
    item.b1_discount = dat ? dat.b1_discount : 0;
    item.b2_discount = dat ? dat.b2_discount : 0;
    item.b3_discount = dat ? dat.b3_discount : 0;
    item.d1_discount = dat ? dat.d1_discount : 0;
    item.max_leader_discount = dat ? dat.max_leader_discount : 0;
    if (!dat) {
      item.net_unit_price_usd = 0;
    } else {
      item.net_unit_price_usd = Number(
        (
          item.list_unit_price_usd *
          (1 - item.b1_discount / 100) *
          (1 - item.b2_discount / 100) *
          (1 - item.b3_discount / 100) *
          (1 - item.d1_discount / 100)
        ).toFixed(4)
      );
    }
    item = await this.itemRecalc(item, quotation);
    return item;
  }

  async itemRecalc(item, quotation) {
    if (!quotation.recalculating) {
      quotation.recalculating = true;
      /*eslint-disable */
      switch (quotation.recalc_field) {
        case "unit_price_usd":
          item.unit_price_usd = Number(
            (
              item.net_unit_price_usd *
              (1-(item.company_discount+item.leader_discount)/100) *
              (1+item.interest/100)
            ).toFixed(4)
          );
          break;
        case "leader_discount":
          if (item.list_unit_price_usd != 0) {
            item.leader_discount = Number(
              (
                (
                  100 * (
                    1 - (
                      (
                        (item.unit_price_usd / (1+item.interest/100)) / item.net_unit_price_usd
                      )
                    )
                  )
                ) -
                item.company_discount
              ).toFixed(6)
            );
          } else {
            item.lider_discount = 0;
          }
          break;
        case "company_discount":
          if (item.list_unit_price_usd != 0) {
            item.company_discount = Number(
              (
                (
                  100 * (
                    1 - (
                      (
                        (item.unit_price_usd / (1+item.interest/100)) / item.net_unit_price_usd
                      )
                    )
                  )
                ) -
                item.leader_discount
              ).toFixed(6)
            );
          } else {
            item.company_discount = 0;
          }
        break;
      }
      /*eslint-enable */
      if (this.bRoot.isNullOrEmpty(item, "company_discount", 0) !== 0) {
        item.company_discount_motive_required = true;
      } else {
        item.company_discount_motive_required = false;
        item = await this.setItemCompanyDiscountMotive(item, quotation);
      }
      item = await this.itemTotalComisionRecalc(item, quotation);
      quotation.recalculating = false;
      return item;
    }
    return item;
  }

  async itemTotalComisionRecalc(item, quotation) {
    /* eslint-disable */
    item.spot_unit_price_usd = Number((item.net_unit_price_usd * (1-(Number(item.company_discount)+Number(item.leader_discount))/100)).toFixed(4));
    item.total_commission_usd = Number((item.net_unit_price_usd * item.quantity * (item.max_leader_discount - item.leader_discount) / 100).toFixed(2));
    item.percentage_commission = Number((this.bRoot.isNullOrEmpty(item, "spot_unit_price_usd", 0) !== 0 ? item.net_unit_price_usd * (item.max_leader_discount - item.leader_discount) / item.spot_unit_price_usd : 0).toFixed(4));
    if (item.percentage_commission > item.max_leader_discount && quotation.recalc_field == "unit_price_usd") {
      let leader_discount = ((item.max_leader_discount * item.company_discount)/(100-item.max_leader_discount)); //eslint-disable-line
      if (leader_discount <= 0 || leader_discount > item.max_leader_discount || leader_discount == item.leader_discount) {
        return item;
      } else {
        item.leader_discount = Math.round(leader_discount*1000000)/1000000
        item.unit_price_usd = Number(
          (
            item.net_unit_price_usd *
            (1-(item.company_discount+item.leader_discount)/100) *
            (1+item.interest/100)
          ).toFixed(4)
        );
        item.spot_unit_price_usd = Number((item.net_unit_price_usd * (1-(Number(item.company_discount)+Number(item.leader_discount))/100)).toFixed(4));
        item.total_commission_usd = Number((item.net_unit_price_usd * item.quantity * (item.max_leader_discount - item.leader_discount) / 100).toFixed(2));
        item.percentage_commission = Number((this.bRoot.isNullOrEmpty(item, "spot_unit_price_usd", 0) !== 0 ? item.net_unit_price_usd * (item.max_leader_discount - item.leader_discount) / item.spot_unit_price_usd : 0).toFixed(4));    
        return item;
      }
    } else {
      return item;
    }
    /* eslint-enable */
  }

  async setItemCompanyDiscountMotive(item, quotation, motive, motiveUrl) {
    if (!motive && motiveUrl) {
      try {
        this.bRoot.disableAlerts = true;
        motive = await this.bRoot.getObjectByURL(motiveUrl);
      } catch {
        motive = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    item.company_discount_motive_object = motive;
    item.company_discount_motive = motive ? motive.url : null;
    item.company_discount_motive_id = motive ? motive.id : 0;
    item.company_discount_motive_code = motive ? motive.code : null;
    item.disable_discount_limit = motive ? motive.disable_discount_limit : false; //eslint-disable-line
    item.company_discount_motive_description = motive ? motive.description : null; //eslint-disable-line
    return item;
  }

  async itemQuantityChange(item, quotation) {
    item = await this.itemTotalComisionRecalc(item, quotation);
    return item;
  }

  async setSaleConditionAllItems(quotation) {
    let new_item = null;
    let index = 0;
    for (let item of quotation.quotation_items) {
      new_item = await this.setSaleCondition(item, quotation);
      quotation.quotation_items.splice(index, 1, new_item);
      index += 1;
    }
    return quotation;
  }

  getNewItem() {
    return {
      id: null,
      item_number: 0,
      product: null,
      product_id: 0,
      product_code: null,
      product_description: null,
      gauge: null,
      gauge_id: 0,
      gauge_code: null,
      gauge_description: null,
      curing: null,
      curing_id: 0,
      curing_code: null,
      curing_description: null,
      crop_id: 0,
      crop_description: null,
      quantity: 0,
      unit_price_usd: 0,
      leader_discount: 0,
      company_discount: 0,
      company_discount_motive_required: false,
      company_discount_motive: null,
      company_discount_motive_id: 0,
      company_discount_motive_code: null,
      company_discount_motive_description: null,
      comment: null,
      serial_number: null,
      band: null,
      band_data: { band_id: 0, band_description: null },
      campaign: null,
      interest: 0,
      b1_discount: 0,
      b2_discount: 0,
      b3_discount: 0,
      d1_discount: 0,
      max_leader_discount: 0,
      total_commission_usd: 0,
      percentage_commission: 0,
      list_unit_price_usd: 0,
      net_unit_price_usd: 0,
      spot_unit_price_usd: 0
    };
  }

  async save(quotation) {
    quotation = await this.defaultValuesquotation(quotation);
    await this.validateQuotation(quotation);

    let added = null;
    if (quotation.url) {
      added = await this.bRoot.save(quotation);
    } else {
      added = await this.bRoot.add("/data/quotations", null, quotation);
    }
    return added;
  }

  async changeState(quotation, state_code) {
    let endpoint =
      "/data/quotations/change_state/" +
      quotation.campaign_id.toString() +
      "/" +
      quotation.id.toString() +
      "/" +
      state_code.toString() +
      "/";
    await this.bRoot.axios.post(endpoint);
  }

  async purgeState(campaign_code) {
    let endpoint =
      "/data/quotations/purge_state/" + campaign_code.toString() + "/";
    await this.bRoot.axios.post(endpoint);
  }

  async printInternal(quotation) {
    let endpoint = `${this.bRoot.API_SERVER}/data/quotations/${quotation.campaign_id.toString()}/${quotation.id.toString()}/PDF/internal`; //eslint-disable-line
    window.open(endpoint, "_blank", "noreferrer");
  }

  async printClient(quotation) {
    let endpoint = `${this.bRoot.API_SERVER}/data/quotations/${quotation.campaign_id.toString()}/${quotation.id.toString()}/PDF/client`; //eslint-disable-line
    window.open(endpoint, "_blank", "noreferrer");
  }

  async defaultValuesquotation(quotation) {
    let defaultState = await this.bRoot.search(
      "/data/quotation_states",
      null,
      null,
      "default=true"
    );
    if (defaultState.data.results.length > 0) {
      quotation.state = defaultState.data.results[0].url;
    } else {
      quotation.state = null;
    }
    quotation.errors = null;

    let sale_methods = await this.getSalesMethods();
    let nonDealerSaleMethodURL = null;
    let dealerSaleMethodURL = null;
    if (sale_methods.data.results) {
      sale_methods.data.results.forEach(element => {
        if (element.code === "6") {
          dealerSaleMethodURL = element.url;
        }
        if (element.code === "4") {
          nonDealerSaleMethodURL = element.url;
        }
      });
    }
    if (quotation.person_category_code == "5") {
      quotation.sale_method = nonDealerSaleMethodURL;
    } else {
      quotation.sale_method = dealerSaleMethodURL;
    }
    return quotation;
  }

  async validateQuotation(quotation) {
    /* Campo obligatorio Persona */
    if (!quotation.person) {
      throw "Debe ingresar Persona";
    }

    /* Campo obligatorio Comercial */
    if (!quotation.commercial_person) {
      throw "No se pudo identificar al comercial logueado";
    }

    /* Campo campaña es obligatorio */
    if (!quotation.campaign) {
      throw "Debe ingresar Campaña";
    }

    /* Campo cultivo es obligatorio */
    if (!quotation.crop) {
      throw "Debe ingresar Cultivo";
    }

    /* Campo obligatorio condición de pago */
    if (!quotation.payment_condition) {
      throw "Debe ingresar Cóndición de Pago";
    }

    /* Campo Obligatorio Estado */
    if (!quotation.state) {
      throw "No se ha definido estado por defecto, comuniquése con el administrador del sistema";
    }

    /* Validate items not empty */
    if (quotation.quotation_items.length === 0) {
      throw "El comprobante debe tener al menos un ítem";
    }
  }

  async validateQuotationItemsMultiCrop(quotation) {
    let crop_id = quotation.crop_id;
    let crop_description = quotation.crop_description;

    for (let item of quotation.quotation_items) {
      if (
        crop_id !== this.bRoot.isNullOrEmpty(item, "crop_id", 0) &&
        item.crop_description
      ) {
        throw {
          message:
            "Item '" +
            item.item_number.toString() +
            "' cultivo '" +
            item.crop_description +
            "' difiere cultivo asignado a la Nota de Venta '" +
            crop_description +
            "'"
        };
      }
    }
  }

  async validateQuotationItem(quotation, item) {
    /* eslint-disable */
    if (!item.product) {
      throw {
        message: "Item '" + item.item_number.toString() + "' ingrese Producto"
      };
    }
    if (this.bRoot.isNullOrEmpty(item, "quantity")) {
      throw {
        message: "Item '" + item.item_number.toString() + "' ingrese Cantidad"
      };
    }
    if (
      !this.bRoot.isNullOrEmpty(item, "company_discount") &&
      !item.company_discount_motive
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' debe ingresar motivo del descuento LG"
      };
    }
    if (
      parseFloat(item.leader_discount) > parseFloat(item.max_leader_discount)
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Descuento Agente supera valor permitido (Max.Dto.Agente) " +
          item.max_leader_discount.toString()
      };
    }
    if (
      parseFloat(item.company_discount) > (100 - parseFloat(item.max_leader_discount))
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Descuento LG supera valor permitido (100 - Max.Dto.Agente) " +
          (100 - parseFloat(item.max_leader_discount)).toString()
      };
    }
    if (
      (1 - item.spot_unit_price_usd / item.list_unit_price_usd) * 100 > quotation.crop_campaign_parameters_object.max_discount
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Precio Contado '" +
          (item.spot_unit_price_usd).toFixed(4).toString() +
          "' debe ser superior al '" +
          (100 - quotation.crop_campaign_parameters_object.max_discount).toFixed(2).toString() +
          " %' del precio de lista '" +
          item.list_unit_price_usd.toString() +
          "': '" +
          (item.list_unit_price_usd * (100 - quotation.crop_campaign_parameters_object.max_discount) / 100).toFixed(4).toString() +
          "' la suma de Descuento Agente más Descuento LG debe ser igual o inferior a '" +
          ((1 - (item.list_unit_price_usd * (100 - quotation.crop_campaign_parameters_object.max_discount) / 100) / item.net_unit_price_usd )  *100).toFixed(6).toString() +
          "'"
      };
    }
    if (
      !this.bRoot.isNullOrEmpty(item, "company_discount") &&
      item.disable_discount_limit === false &&
      parseFloat(item.percentage_commission) > parseFloat(item.max_leader_discount)
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "', Comision Porcentual '" +
          parseFloat(item.percentage_commission).toFixed(2).toString() +
          " %' " +
          "supera Max.Dto.Agente '" +
          parseFloat(item.max_leader_discount).toFixed(2).toString() +
          "'"
      };
    }
    if ( parseFloat(item.leader_discount) < 0 ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' descuento Agente debe ser mayor o igual a cero "
      };
    }
    if ( parseFloat(item.company_discount) < 0 ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' descuento LG debe ser mayor o igual a cero "
      };
    }
    if ( parseFloat(item.unit_price_usd) < 0 ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' El precio de venta financiado debe ser mayor a cero "
      };
    }
  }
  /* eslint-enable */
}
